module.exports = ".actions-panel{width:200px}.actions-panel tasks-button,.actions-panel search-rc-button,.actions-panel day-order-rc-button{width:100%}\n"